import React from 'react';
import {
  Box,
  Avatar,
  Typography,
  Button,
  Menu,
  MenuItem,
  Divider,
  Chip
} from '@mui/material';
import {
  Person as PersonIcon,
  ExitToApp as LogoutIcon,
  Settings as SettingsIcon,
  Search as SearchIcon
} from '@mui/icons-material';
import { useUser } from '../../contexts/UserContext';
import { useNavigate } from 'react-router-dom';

const UserStatus = ({ onLoginClick, onLogoutClick }) => {
  const { 
    user, 
    isLoggedIn, 
    isLoading, 
    logout, 
    getDisplayName, 
    getAvatar,
    hasWechat,
    isEmailVerified,
    isPhoneVerified
  } = useUser();
  
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    handleClose();
    if (onLogoutClick) onLogoutClick();
  };

  const handleApplicationQuery = () => {
    navigate('/application-query');
    handleClose();
  };

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2" color="text.secondary">
          加载中...
        </Typography>
      </Box>
    );
  }

  if (!isLoggedIn) {
    return (
      <Button 
        variant="outlined" 
        startIcon={<PersonIcon />}
        onClick={onLoginClick}
        sx={{ 
          borderRadius: 2,
          textTransform: 'none',
          px: 2
        }}
      >
        登录
      </Button>
    );
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {/* 用户头像和名称 */}
      <Button
        onClick={handleClick}
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 1,
          textTransform: 'none',
          color: 'text.primary',
          px: 1,
          py: 0.5,
          borderRadius: 2,
          '&:hover': {
            backgroundColor: 'action.hover'
          }
        }}
      >
        <Avatar 
          src={getAvatar()} 
          sx={{ width: 32, height: 32 }}
        >
          {getDisplayName().charAt(0)}
        </Avatar>
        <Box sx={{ textAlign: 'left' }}>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {getDisplayName()}
          </Typography>
          <Box sx={{ display: 'flex', gap: 0.5, mt: 0.5 }}>
            {hasWechat() && (
              <Chip 
                label="微信" 
                size="small" 
                color="success" 
                variant="outlined"
                sx={{ height: 16, fontSize: '0.7rem' }}
              />
            )}
            {isEmailVerified() && (
              <Chip 
                label="邮箱" 
                size="small" 
                color="primary" 
                variant="outlined"
                sx={{ height: 16, fontSize: '0.7rem' }}
              />
            )}
            {isPhoneVerified() && (
              <Chip 
                label="手机" 
                size="small" 
                color="secondary" 
                variant="outlined"
                sx={{ height: 16, fontSize: '0.7rem' }}
              />
            )}
          </Box>
        </Box>
      </Button>

      {/* 用户菜单 */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            minWidth: 200,
            mt: 1
          }
        }}
      >
        {/* <MenuItem onClick={handleClose}>
          <PersonIcon sx={{ mr: 1 }} />
          个人资料
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <SettingsIcon sx={{ mr: 1 }} />
          账户设置
        </MenuItem> */}
        <MenuItem onClick={handleApplicationQuery}>
          <SearchIcon sx={{ mr: 1 }} />
          申请查询
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout} sx={{ color: 'error.main' }}>
          <LogoutIcon sx={{ mr: 1 }} />
          退出登录
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default UserStatus;
